window.specialistsPageService = {
    async getSpecialistsPage(params = {}) {
        const response = await fetch(window.appConfig.routes.getSpecialistsPage, {
            method: 'post',
            headers: {
                'X-CSRF-TOKEN': window.appConfig.csrfToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params),
        });

        if (!response.ok) {
            return {
                status: response.status,
                data: [],
                detail: {
                    page: Number(params.page || 1),
                    limit: Number(params.limit || 12),
                    pages_count: 1,
                    rows_count: 0,
                },
            };
        }

        return await response.json();
    },
};